import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@hub-la/shadcn'
import { X } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  open: boolean
  onClose: () => void
  onSubmit: () => void
}

export const VisibilityModal: React.FC<Props> = (props) => {
  const { open, onClose, onSubmit } = props
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <div className="flex items-center justify-between w-full">
            <DialogTitle className="text-2xl font-semibold">{t('visibilityModal.title')}</DialogTitle>

            <Button variant="ghost" size="icon" onClick={onClose}>
              <X className="h-4 w-4" />
            </Button>
          </div>
        </DialogHeader>

        <div>
          <p>{t('visibilityModal.subtitle')}</p>
        </div>

        <DialogFooter>
          <div className="w-full flex flex-col-reverse sm:flex-row gap-2 sm:justify-end">
            <Button variant="ghost" onClick={onClose}>
              {t('visibilityModal.cancel')}
            </Button>
            <Button variant="default" onClick={onSubmit}>
              {t('visibilityModal.submit')}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
